import ReactDOM from "react-dom";
import { primaryFont } from "../../../other/theme";
import styled from "@emotion/styled";
import { level50 } from "../../../other/theme/opacities";
import { useCallback } from "react";

interface IProps {
    children: React.ReactNode;
    zIndex?: number;
    pointerEventsAuto?: boolean;
}

export const PopupContainer = (props: IProps) => {
    const onClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
        // fixes a bug whereby click events can be wrongly fired. eg, in the case log, when the delete popup is open, clicking anywhere causes the click event of the row to trigger
        event.stopPropagation();
        // perform click on body element to trigger closes for hovered elements
        document.body.click();
    }, []);

    return ReactDOM.createPortal(
        <Overlay
            zIndex={props.zIndex}
            pointerEventsAuto={props.pointerEventsAuto}
            onClick={onClick}
        >
            {props.children}
        </Overlay>,
        document.body
    );
};

const Overlay = styled("div")<{
    zIndex?: number;
    pointerEventsAuto?: boolean;
}>(props => ({
    width: "100%",
    height: "100%",
    position: props.zIndex !== undefined ? "fixed" : "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: 40,
    backgroundColor: props.theme.shadow + level50,
    fontFamily: primaryFont,
    zIndex: props.zIndex ?? 3,
    // Fixes interaction issue when popup is opened from within a React Dialog
    pointerEvents: props.pointerEventsAuto ? "auto" : undefined
}));
